import { Button, ButtonGroup } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { useAppContext } from "../../context";
import { checkRole, reducerFn } from "../../helper";
import { useSelectRowsCtx } from "../shared/SelectRow";
import MemberActionVerify from "./member-action-verify";

export default function MemberBulkAction() {
    const { currentUser } = useAppContext();
    const { isSeller } =
        checkRole(currentUser);

    const [state, setState] = useReducer(reducerFn, {
        open: false,
        action: null,
    });

    const { ids, onCompleted, refetch } = useSelectRowsCtx();

    const toggleShowModal = useCallback((action) => {
        setState((p) => ({ ...p, open: !p.open, action }));
    }, []);

    const props = {
        open: state.open,
        toggleShowModal,
        onClose: toggleShowModal,
        onCompleted,
        ids,
        refetch,
    };

    const actionsMarkup = {
        verify: <MemberActionVerify {...props} />,
    };

    return (
        <>
            <ButtonGroup segmented>
                {isSeller ? (
                    <Button
                        children="Mark Verify"
                        onClick={() => toggleShowModal("verify")}
                        disclosure
                    />
                ) : null}
            </ButtonGroup>
            {actionsMarkup[state.action] || null}
        </>
    );
}
